<!--
 * @version: V1.0.0
 * @Date: 2022-12-05 15:18:22
 * @LastEditors: lzq
 * @LastEditTime: 2023-10-08 16:12:50
 * @company: 睿展数据
 * @FilePath: \udi-web\src\pages\system\user\profile\resetPwd.vue
 * @Descripttion:
-->
<template>
  <el-form ref="form" :model="user" :rules="rules" label-width="80px" class="p-3">
    <el-form-item label="旧密码" prop="oldPassWord">
      <el-input
        v-model="user.oldPassWord"
        placeholder="请输入旧密码"
        type="password"
        show-password
      />
    </el-form-item>
    <el-form-item label="新密码" prop="newPassWord">
      <el-input
        v-model="user.newPassWord"
        placeholder="请输入新密码"
        type="password"
        show-password
      />
    </el-form-item>
    <el-form-item label="确认密码" prop="confirmPassword">
      <el-input
        v-model="user.confirmPassword"
        placeholder="请确认密码"
        type="password"
        show-password
      />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" size="mini" @click="submit">保存</el-button>
      <el-button size="mini" @click="close">关闭</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { updateUserPwd } from '@/api/login'

export default {
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.user.newPassWord !== value) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/ // matches 11-digit mobile numbers starting with 1
      if (value && !passwordPattern.test(value)) {
        callback(new Error('请输入6位数以上大小写字母+数字的密码'))
      } else {
        callback()
      }
    }

    return {
      test: '1test',
      user: {
        oldPassWord: '',
        newPassWord: '',
        confirmPassword: '',
        userId: ''
      },
      // 表单校验
      rules: {
        oldPassWord: [{ required: true, message: '旧密码不能为空', trigger: 'blur' }],
        newPassWord: [
          { required: true, message: '新密码不能为空', trigger: 'blur' },
          { required: true, validator: validatePassword, trigger: ['blur', 'change'] }
        ],
        confirmPassword: [
          { required: true, message: '确认密码不能为空', trigger: 'blur' },
          { required: true, validator: equalToPassword, trigger: 'blur' }
        ]
      }
    }
  },
  props: ['userId'],
  methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.user.userId = this.userId
          delete this.user.confirmPassword

          updateUserPwd(this.user).then((response) => {
            this.$message({
              type: 'success',
              message: '保存成功'
            })
          })
        }
      })
    },
    close() {
      this.$store.dispatch('tagsView/delView', this.$route)
      this.$router.push({ path: '/statistics' })
    }
  }
}
</script>

<style scoped>
.el-input {
  width: 300px;
}
</style>
